export default {
    pattern: {
        value: /[A-HJ-NPR-Z0-9]{17}/i,
        message: 'Wpisz poprawny VIN',
    }
}